import { Pressable, View } from "react-native";
import React, { useEffect } from "react";
import { Text } from "@ui-kitten/components";
import { Field, Formik } from "formik";
import TextInput from "components/TextInput";
import { FinishSignupScreenProps } from "navigation/types";
import Button from "components/Button";
import { useAppSelector } from "hooks/useAppSelector";
import { useAppDispatch } from "hooks/useAppDispatch";
import { login } from "features/slices/authSlice";
import { useMutation } from "@tanstack/react-query";
import { resetPasswordFetcher } from "queries/user.queries";
import {
  InitialValues,
  validationSchema,
} from "screens/ResetPassword/ResetPassword";
import LoginContainer from "components/LoginContainer";
import { loginInputProps } from "screens/Login/Login";
import { AUTH_SCREEN_BUTTON_BACKGROUND } from "constants/";
import i18n from "plugins/localization";
import { toDashboard } from "utils/navigationUtils";

const FinishSignup = ({ navigation, route }: FinishSignupScreenProps) => {
  const { encodedEmail, token } = route.params;
  const storedUserId = useAppSelector((state) => state.auth.id);
  const dispatch = useAppDispatch();

  const initialValues: InitialValues = {
    password: "",
    confirmPassword: "",
  };

  const { mutateAsync: resetPassword, isLoading } =
    useMutation(resetPasswordFetcher);

  const onSubmit = async (values: InitialValues) => {
    const decodedEmail = window.atob(decodeURIComponent(encodedEmail));
    await resetPassword({
      ...values,
      username: decodedEmail,
      token,
    });
    await dispatch(
      login({ username: decodedEmail, password: values.password })
    );
  };

  useEffect(() => {
    if (storedUserId) {
      toDashboard();
    }
  }, [storedUserId]);
  return (
    <LoginContainer title={i18n.t("screens.FinishSignup.title")}>
      <View style={{ padding: 15 }}>
        <Text style={{ marginVertical: 15 }} status="control">
          {i18n.t("screens.FinishSignup.heading")}
        </Text>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isValid, handleSubmit }) => (
            <View>
              <View style={{ marginVertical: 10 }}></View>
              <Field
                component={TextInput}
                name="password"
                appearance="default"
                secureTextEntry
                label={
                  <Text status="control">{i18n.t("labels.password")}</Text>
                }
                {...loginInputProps}
              ></Field>
              <View style={{ marginVertical: 10 }}></View>

              <Field
                component={TextInput}
                name="confirmPassword"
                appearance="default"
                secureTextEntry
                label={
                  <Text status="control">
                    {i18n.t("labels.confirmPassword")}
                  </Text>
                }
                {...loginInputProps}
              ></Field>
              <View style={{ marginVertical: 10 }}></View>

              <Button
                style={{
                  marginVertical: 10,
                  backgroundColor: AUTH_SCREEN_BUTTON_BACKGROUND,
                  borderWidth: 0,
                }}
                disabled={!isValid}
                onPress={() => handleSubmit()}
                loading={isLoading}
              >
                {i18n.t("common.submit")}
              </Button>
              <Pressable
                onPress={() =>
                  navigation.navigate("LoginFlow", { screen: "Login" })
                }
              >
                <Text style={{ color: "white", textAlign: "center" }}>
                  {i18n.t("common.logIn")}
                </Text>
              </Pressable>
            </View>
          )}
        </Formik>
      </View>
    </LoginContainer>
  );
};

export default FinishSignup;
